'use strict';
// var utils = require('pagedesigner/util/utils');
// var scrollPos = 0;

/**
 * Detect and return the scroll vertical direction
  * @returns {string} - scroll direction
 */
/* function scrollVerticalDirection() {
    var scrollDirection = document.body.getBoundingClientRect().top > scrollPos ? 'up' : 'down';
    scrollPos = document.body.getBoundingClientRect().top;
    return scrollDirection;
}*/

/**
 * Scroll header brands logos
 * @param {jQuery} e active logo
 */
function headerBrandsLogoScroll(e) {
    if ((e.offset().left + e.outerWidth()) > $(window).outerWidth()) {
        $('.header-logo-Div').animate({ scrollLeft: e.offset().left });
    }
}

module.exports = {
    /**
     * JS observer to detect when a target element is scrolled outside the viewport, toggling a class on site-header to handle "stuck" state via SCSS
     */
    initUserDropdownAccessibility: function () {
        const $userContainer = $('.user');

        // Handle keyboard on trigger icon
        $userContainer.on('keydown', 'a[role="button"]', function (e) {
            const $menu = $(this).siblings('.popover');
            const $items = $menu.find('a[role="menuitem"]');

            if (e.key === 'ArrowDown') {
                e.preventDefault();
                $menu.addClass('show');
                $items.first().focus();
            }

            if (e.key === 'ArrowUp') {
                e.preventDefault();
                $menu.addClass('show');
                $items.last().focus();
            }
        });

        // Handle keyboard navigation inside dropdown
        $userContainer.on('keydown', '.popover a[role="menuitem"]', function (e) {
            const $items = $(this).closest('.popover').find('a[role="menuitem"]');
            const index = $items.index(this);

            if (e.key === 'ArrowDown') {
                e.preventDefault();
                const nextIndex = (index + 1) % $items.length;
                $items.eq(nextIndex).focus();
            }

            if (e.key === 'ArrowUp') {
                e.preventDefault();
                const prevIndex = ((index - 1) + $items.length) % $items.length;
                $items.eq(prevIndex).focus();
            }

            if (e.key === 'Escape') {
                e.preventDefault();
                const $trigger = $(this).closest('.user').find('a[role="button"]');
                $(this).closest('.popover').removeClass('show');
                $trigger.focus();
            }

            if (e.key === 'Tab' && e.shiftKey) {
                e.preventDefault();
                const $trigger = $('.search-toggle-btn');
                $trigger.focus();
            }
        });
    },

    initStickyHeader: function () {
        const target = document.querySelector('.sticky-scroll-trigger');
        const stickyHeader = document.querySelector('.sticky-header');

        if (!target || !stickyHeader || !('IntersectionObserver' in window)) {
            return;
        }

        let originalHeight = stickyHeader.offsetHeight;
        let stuckHeight = 0;
        let isStuck = false;
        let debounceTimer = null;

        const measureHeights = function () {
            const $header = $('.site-header');
            const currentlyStuck = $header.hasClass('is-stuck');

            originalHeight = currentlyStuck ?
                ($header.removeClass('is-stuck animation-none'), stickyHeader.offsetHeight) :
                stickyHeader.offsetHeight;

            $header.addClass('is-stuck animation-none');
            stuckHeight = stickyHeader.offsetHeight;
            $header.toggleClass('is-stuck', currentlyStuck).removeClass('animation-none');

            document.body.style.setProperty('--var-padding-top', `${originalHeight - stuckHeight}px`);
        };

        const applyStuckState = function (shouldStick) {
            if (isStuck === shouldStick) return;

            isStuck = shouldStick;

            requestAnimationFrame(() => {
                document.body.style.setProperty('--var-padding-top',
                    shouldStick ? `${originalHeight - stuckHeight}px` : '0px');

                $('.site-header')
                    .removeClass('animation-none')
                    .toggleClass('is-stuck', shouldStick);
            });
        };

        measureHeights();
        window.addEventListener('resize', measureHeights);

        new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                clearTimeout(debounceTimer);
                debounceTimer = setTimeout(() => {
                    applyStuckState(!entry.isIntersecting && !$('.menu-toggleable-left').hasClass('in'));
                }, 50);
            });
        }, { rootMargin: '0px', threshold: 0 }).observe(target);

        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', () => {
                if (window.scrollY <= 1) {
                    clearTimeout(debounceTimer);
                    applyStuckState(false);
                }
            });
        }
    },

    /**
     * Scroll event to control search field auto expand / collapse depending of scroll vertical direction for mobile devices
     */
    /* initSearchScrollBehavior: function () {
        if (utils.isMobile()) {
            $(window).on('scroll.search', debounce(function () {
                if ($('.js-expandable-search .search-field').is(':focus')) {
                    return;
                }

                var scrollDirection = scrollVerticalDirection();
                var searchIsExpanded = $('.js-expandable-search').hasClass('show');
                var isDesktopNav = window.matchMedia('(min-width: 992px)').matches;
                var isNavStuck = $('.site-header').is('.is-stuck');
                var isSearchSuggestionsOpen = $('.suggestions.modal').is(':visible');

                if (
                    (scrollDirection === 'down' && searchIsExpanded && !isSearchSuggestionsOpen && isNavStuck && !isDesktopNav) ||
                    (scrollDirection === 'up' && !searchIsExpanded && !isDesktopNav)
                ) {
                    $('.js-expandable-search').collapse('toggle');
                }
            }, 50, {
                leading: true,
                trailing: false,
                maxWait: 200
            }));
        }
    },*/

    initExpandableSearchEvents: function () {
        const $searchContainer = $('.search');
        const $searchField = $searchContainer.find('.search-field');
        const isUaHeader = $('.header-ua').length > 0;

        /**
         * Toggles the search container and updates the aria-expanded attribute
         */
        function toggleSearch() {
            const isShowing = $searchContainer.attr('aria-expanded') !== 'true';

            $(this).attr('aria-expanded', isShowing);
            $searchContainer.attr('aria-expanded', isShowing);

            if (isShowing) {
                $searchField.trigger('focus');
            } else {
                $searchField.trigger('blur');
            }
        }

        /**
         * UA mobile uses a visible search box instead of the icon toggle.
         * @returns {boolean} true when the UA mobile search treatment applies
         */
        function isUaMobileSearch() {
            return isUaHeader && window.matchMedia('(max-width: 1024px)').matches;
        }

        /**
         * Expands the search field using the existing aria-expanded contract
         */
        function expandSearch() {
            if ($searchContainer.attr('aria-expanded') === 'true') {
                return;
            }

            $searchContainer.attr('aria-expanded', 'true');
            $('.search-toggle-btn').attr('aria-expanded', 'true');
        }

        // Toggle search when clicking any element with search-toggle-btn class
        $(document).off('click', '.search-toggle-btn').on('click', '.search-toggle-btn', function (e) {
            e.preventDefault();
            e.stopPropagation();
            toggleSearch();
        });

        if (isUaHeader) {
            $searchField.on('focus', function () {
                if (isUaMobileSearch()) {
                    expandSearch();
                }
            });

            $searchContainer.on('click', '.search-button', function (e) {
                if (isUaMobileSearch() && $searchContainer.attr('aria-expanded') !== 'true') {
                    e.preventDefault();
                    expandSearch();
                    $searchField.trigger('focus');
                }
            });
        }
    },

    headerLogoLink: function () {
        $('body').on('click', 'a.header-logo', function () {
            $(this).addClass('active');
            headerBrandsLogoScroll($(this));
        });

        $('a.header-logo').each(function () {
            var currentUrl = window.location.pathname;
            var currentHref = this.pathname;
            if (currentHref === currentUrl) {
                $(this).addClass('activated');
                headerBrandsLogoScroll($(this));
            }
        });
    }
};
